import KnowledgePage from "@/modules/resources/pages/knowledge";
import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { object, enum as zodEnum } from "zod";

export const Route = createFileRoute(
  "/(auth)/_headed/resources/_layout/knowledge"
)({
  component: RouteComponent,
  validateSearch: zodValidator(
    object({
      category: zodEnum(["newsletter", "article", "tutorial", "guide"]).default(
        "newsletter"
      ),
    })
  ),
});

function RouteComponent() {
  return <KnowledgePage />;
}
